import React from 'react';
import './RecruiterSection.css';
import { useTranslation } from 'react-i18next';

const RecruiterSection = ({ id = 'recruiter-section' }) => {
  const { t, i18n } = useTranslation();

  // --- Custom recruiter content per language ---
  const content = {
    fr: {
      // Highlight "Tunisie" in accent color
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html:
              "Recrutez les meilleurs talents en soins infirmiers de <span class='accent-color'>Tunisie.</span> - Rapide. Qualifié. Fiable."
          }}
        />
      ),
      desc: "Accédez à un vivier exclusif d’infirmier·ère·s tunisien·ne·s qualifié·e·s, présélectionné·e·s et prêt·e·s à intégrer votre établissement de santé en Allemagne. Grâce à notre solution de recrutement 360°, vous gagnez du temps, réduisez les risques et intégrez des profils engagés, accompagnés de bout en bout.",
      promise: "Notre promesse :",
      bullets: [
        "✔️ Vérification rigoureuse des diplômes et compétences linguistiques (B2 minimum)",
        "✔️ Processus de recrutement et de reconnaissance accélérés",
        "✔️ Accompagnement personnalisé pour la relocalisation et l’intégration culturelle",
        "✔️ Suivi continu après l’arrivée – pour garantir la satisfaction des deux parties"
      ],
      cta: "Commencer le recrutement"
    },
    de: {
      // Highlight "Tunesien" in accent color
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html:
              "Rekrutieren Sie Top‑Pflegekräfte aus <span class='accent-color'>Tunesien</span> – Schnell, Qualifiziert, Verlässlich."
          }}
        />
      ),
      desc: "Greifen Sie auf einen geprüften Pool hochqualifizierter Pflegefachkräfte aus Tunesien zu, die bereit sind, Ihr Team in Deutschland zu verstärken. Mit unserem ganzheitlichen Recruiting‑Service erhalten Sie nicht nur die passenden Kandidat:innen – wir begleiten den gesamten Prozess von A bis Z.",
      promise: "Ihre Vorteile mit ProConnet TN:",
      bullets: [
        "✔️ Sorgfältige Prüfung von Qualifikation & Sprachkompetenz (B2‑Niveau)",
        "✔️ Schnelle Rekrutierung & Anerkennungsverfahren",
        "✔️ Vollständige Unterstützung bei Einreise, Umzug & Integration",
        "✔️ Laufendes Onboarding‑Monitoring & Zufriedenheits‑Check"
      ],
      cta: "Jetzt rekrutieren"
    }
  };

  const lang = i18n.language === 'de' ? 'de' : 'fr';
  const c = content[lang];

  return (
    <section className="recruiter-section" id={id}>
      <div className="recruiter-grid">
        <div className="recruiter-left">
          <div className="recruiter-left-inner">
            <div className="recruiter-title-card">
              <h2 className="recruiter-title-main">{c.title}</h2>
            </div>
            <div className="recruiter-paragraph-card">
              <p className="recruiter-description">
                {c.desc}
              </p>
              <div style={{ fontWeight: 700, marginBottom: '0.7rem', color: '#2563eb' }}>{c.promise}</div>
              <ul className="recruiter-benefits-list">
                {c.bullets.map((b, i) => <li key={i}>{b}</li>)}
              </ul>
              <button className="recruiter-cta-btn">{c.cta}</button>
            </div>
          </div>
        </div>
        <div className="recruiter-right">
          <div className="feature-card enhanced-card">
            <div className="card-accent-bar accent-blue"></div>
            <img src={require('../assets/users.svg').default || require('../assets/users.svg')} alt={t('recruiter_card1_icon_alt')} className="feature-icon" />
            <div>
              <div className="feature-title">{t('recruiter_card1_title')}</div>
              <div className="feature-desc">{t('recruiter_card1_desc')}</div>
            </div>
          </div>
          <div className="feature-card enhanced-card">
            <div className="card-accent-bar accent-indigo"></div>
            <img src={require('../assets/clock.svg').default || require('../assets/clock.svg')} alt={t('recruiter_card2_icon_alt')} className="feature-icon" />
            <div>
              <div className="feature-title">{t('recruiter_card2_title')}</div>
              <div className="feature-desc">{t('recruiter_card2_desc')}</div>
            </div>
          </div>
          <div className="feature-card enhanced-card">
            <div className="card-accent-bar accent-orange"></div>
            <img src={require('../assets/documents-support.svg').default || require('../assets/documents-support.svg')} alt={t('recruiter_card3_icon_alt')} className="feature-icon" />
            <div>
              <div className="feature-title">{t('recruiter_card3_title')}</div>
              <div className="feature-desc">{t('recruiter_card3_desc')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecruiterSection;
